import { render, staticRenderFns } from "./contact-card.vue?vue&type=template&id=29f59524&scoped=true&"
import script from "./contact-card.vue?vue&type=script&lang=js&"
export * from "./contact-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f59524",
  null
  
)

export default component.exports